export const eventer = () => {
  const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
  return window[eventMethod];
};

export const messageEvent = () => {
  const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
  return eventMethod === 'attachEvent' ? 'onmessage' : 'message';
};
